module.exports = "<div class=divider-group> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox name=\"{%- name %}\" value=\"{%- value %}\" data-column-index=\"{%- columnIndex %}\" class=column-modal-input {% if (!canToggle) { %} disabled=disabled {% } %}{% if (active) { %} checked=checked {% } %}/> <span class=cb-label-inner> {%- title %} </span> </label> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/columnModalCheckbox.html
// module id = 1145
// module chunks = 1